import { Fragment, ReactElement } from 'react';
import PersonMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage-non-resident/edit-person';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonMarriageNonResidentNotificationsCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

PersonMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonMarriageNonResidentNotificationsCivilStatusPage;
